import { fromJS } from 'immutable';

import { ApiUrl2, UserToken } from '../../../helper/HelperAuth'
import { GetReply, GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (page, search, body) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true });
    const Authorization = UserToken;

    const url = ApiUrl2 + 'config-replies-list';

    if (page === undefined) {
        page = 1;
    }
    var query = {
        "search": body,
        "page": page,
        "page-size": 10,
        "order-by": 1,
        "order": "ASC",
    };

    if (search != null) {
        search.map((v, k) => {
            if (v !== "") {
                query[k] = v;
            }
        });
    }
    var paramBody = {
        "query": query
    };

    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(paramBody)
    };

    const response = await doFetch(url, argument);
    var data = fromJS({});
    var listdata = fromJS({})
    var button = ''
    var option = ''
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get('query-result');
        listdata = data.get('data')
        for (let i = 0; i < listdata.size; i++) {
            var subdata = listdata.get(i)
            //debugger
            if (subdata.get("detailInteractive") != undefined) {
                var arraybutton = []
                for (let j = 0; j < subdata.get("detailInteractive").size; j++) {
                    var subtile = subdata.get("detailInteractive").get(j)
                    if (!arraybutton.includes(subtile.get('title'))) {
                        button += "\n"+subtile.get('title') + "\n"
                        arraybutton.push(subtile.get('title'))
                    }
                    if (subtile.get('option') != undefined) {
                        option += "\n"+subtile.get('option') + "\n"
                    } else continue
                }
                subdata = subdata
                    .set('button', button)
                    .set('option', option)
                subdata = subdata.delete("detailInteractive")
                listdata = listdata.set(i, subdata)
                button = ''
                option = ''
            } else continue
        }
    }
    data = data.set('data', listdata)
    dispatch({ type: GlobalLoading, showLoading: false });
    dispatch({ type: GetReply, data: fromJS(data) });
};